import React, { useState } from 'react';
import {
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Tooltip,
} from '@mui/material';

import { ISubmission } from '../../../../../store/SubmissionSlice';
import SubmissionCountdownTimer from './SubmissionCountdownTimer';
import QuizTimeTakenModal from '../../modals/QuizTimeTakenModal';

type TSubmissionTimerProps = {
  submissionData: ISubmission;
  isTimeUpAlertVisible: boolean;
  showTimeUpAlert?: () => void;
};

const SubmissionTimer: React.FC<TSubmissionTimerProps> = ({
  submissionData,
  isTimeUpAlertVisible,
  showTimeUpAlert,
}) => {
  let countDownVal = 0;
  let totalSubmissionSeconds = 0;
  let title = 'Time Remaining';

  if (submissionData.timerStart && submissionData.isTimerEnabled) {
    const allocatedSeconds = Math.floor(submissionData.totalScore * 60);

    if (submissionData.isTimerEnabled && submissionData.timerStart) {
      const timestamp = new Date().getTime();

      totalSubmissionSeconds = Math.floor(
        (timestamp - submissionData.timerStart) / 1000
      );

      if (submissionData.status === 'pending') {
        countDownVal = allocatedSeconds - totalSubmissionSeconds;

        if (
          totalSubmissionSeconds > 0 &&
          allocatedSeconds < totalSubmissionSeconds
        ) {
          title = 'Extra Time Taken';
        }
      } else if (submissionData.status === 'completed') {
        title = 'Time Taken for the Quiz';

        if (submissionData.timerEnd) {
          totalSubmissionSeconds = Math.floor(
            (submissionData.timerEnd - submissionData.timerStart) / 1000
          );

          countDownVal = totalSubmissionSeconds;

          if (allocatedSeconds < totalSubmissionSeconds) {
            title = 'Extra Time Taken';
          }
        }
      }
    }
  }

  // State
  const [
    isTimeTakenForTheQuizModalOpen,
    setTimeTakenForTheQuizModalOpen,
  ] = useState(false);

  const toggleQuizTimeTakenModal = () => {
    setTimeTakenForTheQuizModalOpen((prevState) => !prevState);
  };

  return (
    <>
      <Tooltip title={title} placement="top">
        <Card style={{ borderRadius: '23px', border: '1px solid #E2E8F0' }}>
          <CardActionArea
            disabled={submissionData.status === 'pending'}
            onClick={toggleQuizTimeTakenModal}
          >
            <CardContent style={{ padding: '5px 16px' }}>
              <Stack direction="row" alignItems="center">
                <SubmissionCountdownTimer
                  value={countDownVal}
                  isTimeUpAlertVisible={isTimeUpAlertVisible}
                  run={submissionData.status === 'pending'}
                  showInfoIcon={submissionData.status === 'completed'}
                  showTimeUpAlert={showTimeUpAlert}
                />
              </Stack>
            </CardContent>
          </CardActionArea>
        </Card>
      </Tooltip>
      {/* Modals */}
      {isTimeTakenForTheQuizModalOpen ? (
        <QuizTimeTakenModal
          open={isTimeTakenForTheQuizModalOpen}
          onClose={toggleQuizTimeTakenModal}
        />
      ) : null}
    </>
  );
};

export default SubmissionTimer;
